import * as React from 'react';

import { CombinedScrollToTopProps } from '../../components/navigation/scroll-to-top';

const ScrollToTopView: React.StatelessComponent<CombinedScrollToTopProps> = props => {
    return (
        <a href="" onClick={props.scrollToTop} className="ace-cal-back-to-top btn btn-round" data-show-button={props.showButton}>
            <svg focusable="false" className="svg-icon" aria-hidden="true">
                <use xlinkHref="#icon-to-top" />
            </svg>
            <span className="visually-hidden">
                Scroll to Top
            </span>
        </a>
    )
}

export default ScrollToTopView;